import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useMemo } from 'react';
import { useSnackbar } from 'notistack';
import {
  QueryClient,
  QueryCache,
  QueryClientProvider as BaseQueryClientProvider
} from '@tanstack/react-query';

type MetaConfig = {
  errorMessage?: string;
};

export type QueryClientProviderProps = { children: React.ReactNode };

export const QueryClientProvider = ({ children }: QueryClientProviderProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useMemo(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (_, query) => {
            const meta = (query?.meta ?? {}) as MetaConfig;
            if (meta.errorMessage) {
              enqueueSnackbar(meta.errorMessage, { variant: 'error' });
            }
          }
        })
      }),
    [enqueueSnackbar]
  );

  return (
    <BaseQueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </BaseQueryClientProvider>
  );
};
